import FrasesActions from "./FrasesActions";
import { Icon } from "@iconify/react";

const FraseRow = ({ frase }) => {
  const isActive = frase.is_active;

  return (
    <tr>
      <td>
        <span className="text-md text-secondary-light">
          {frase.frase}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {frase.talento_global_nombre || "Sin talento"}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            frase.is_random
              ? "bg-info-focus text-info-main"
              : "bg-neutral-200 text-neutral-600"
          }`}
        >
          {frase.is_random ? (
            <>
              <Icon icon="mdi:dice-multiple" width="14" className="me-1" />
              Aleatoria
            </>
          ) : (
            "Normal"
          )}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            isActive
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {isActive ? "Activo" : "Inactivo"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <FrasesActions frase={frase} />
        </span>
      </td>
    </tr>
  );
};

export default FraseRow;
